if (!customElements.get("product-multi-buy")) {
    class ProductMultiBuy extends HTMLElement {
        constructor() {
            super();
            this.products = this.querySelectorAll(".product_multi_buy__item"); // 获取所有产品元素
            this.addToCartButton = document.querySelector('.main-add-cart-button');
            this.buyNowButton = document.querySelector('.product__bottom_bar-buy-now');
        }

        connectedCallback() {
            if (this.products.length > 0) {
                this.setupEventListeners();
            }
        }

        setupEventListeners() {
            this.products.forEach(product => {
                const productArea = product.querySelector('.product_multi_buy__item_info');
                if (productArea) {
                    productArea.addEventListener("click", (event) => {
                        if (event.target.closest('quantity-input')) return;
                        this.toggleProductSelection(product);
                    });

                    const qtybox = product.querySelector('.quantity__input[name="quantity"]');
                    if (qtybox) {
                        qtybox.addEventListener('change', () => {
                            this.inputChangeProductSelection(product);
                        });
                    }
                }
            });
        }

        inputChangeProductSelection(product) {
            const checkbox = product.querySelector('input[type="checkbox"]');
            const qtybox = product.querySelector('.quantity__input[name="quantity"]');
            if (!qtybox) return;

            const variantId = checkbox.value;
            const qty = qtybox.value;

            this.updateButtonAttributes(variantId, qty, product);
        }

        toggleProductSelection(product) {
            const checkbox = product.querySelector('input[type="checkbox"]');
            const qtybox = product.querySelector('.quantity__input[name="quantity"]');
            if (!checkbox || !qtybox) return;

            const variantId = checkbox.value;
            const qty = qtybox.value;

            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event('change'));

            this.updateButtonAttributes(variantId, checkbox.checked ? qty : '0', product);
        }

        updateButtonAttributes(variantId, qty, product) {
            const updateAttributes = (button) => {
                let ids = button.getAttribute('data-variant-id')?.split(',') || [];
                let quantities = button.getAttribute('data-quantity')?.split(',') || [];

                const index = ids.indexOf(variantId);

                if (index > -1) {
                    if (qty === '0') {
                        ids.splice(index, 1);
                        quantities.splice(index, 1);
                        product.removeAttribute('selected');
                    } else {
                        quantities[index] = qty;
                        product.setAttribute('selected', '');
                    }
                } else if (qty !== '0') {
                    ids.push(variantId);
                    quantities.push(qty);
                    product.setAttribute('selected', '');
                }

                button.setAttribute('data-variant-id', ids.join(','));
                button.setAttribute('data-quantity', quantities.join(','));
            };

            // 更新两个按钮的属性
            updateAttributes(this.addToCartButton);
            updateAttributes(this.buyNowButton);
        }
    }

    customElements.define("product-multi-buy", ProductMultiBuy);
}
